// Import Custom Conponents

import Header from "./components/Header";
import Sliders from "./components/Sliders";

Header.init();
Sliders.init();

const categoryPickerButton = document.querySelector(".category-picker-button");
if (categoryPickerButton) {
	const picker = document.querySelector(".category-picker");
	categoryPickerButton.addEventListener("click", () => {
		picker.classList.toggle("show-category-picker");
	});
}

var otherMenu = document.querySelector(
	".wp-block-post-content > nav.wp-block-navigation",
);
if (otherMenu) {
	var pos = otherMenu.getBoundingClientRect();
	var scroll = window.scrollY;
	document.addEventListener("scroll", function () {
		// Check if the element with class 'other-menu' exists
		fixMenu();
	});
	document.addEventListener("load", function () {
		// Check if the element with class 'other-menu' exists
		fixMenu();
	});

	const fixMenu = () => {
		scroll = window.scrollY;

		// Add or remove 'scrolling' class to body based on scroll position
		if (scroll >= 10) {
			document.body.classList.add("scrolling");
		} else {
			document.body.classList.remove("scrolling");
		}

		// Get the position of the 'other-menu' element

		if (scroll >= pos.top - 53) {
			otherMenu.classList.add("fixed");
		} else {
			otherMenu.classList.remove("fixed");
		}
	};
}
